<template>
	<Dialog v-model:visible="visible" maximizable modal header="라이선스 정보 수정" :style="{ width: modalWidth }" @update:visible="handleDialogClose">
		<div class="d-flex">
				<Button label="히스토리" @click="visible2 = true, getLicenseHistory()" />
		</div>
		<Dialog v-model:visible="visible2" modal header="히스토리" :style="{ width: modalWidth }" :breakpoints="{ '1199px': '50vw', '575px': '90vw' }">
			<Timeline :value="licenseHistoryList">
				<template #opposite="left" >
					<small class="p-text-secondary">
						{{ left.item.regDate.substring(0,11) }}{{ left.item.regDate.substring(11,16) }}<br>
						{{ left.item.name }}
					</small>
				</template>
				<template #content="right">
					<template v-for="(field, index) in Object.keys(getNextLicenseName(historyHeader, right.item)).map((key) => key)" :key="index">
						<tr v-if="shouldRenderField(historyHeader, right.item, field, index)">
							<td nowrap>
							<small class="p-text-secondary">
								<b>{{ getFieldTitle(historyHeader, right.item, field) }}</b>
							</small>
							</td>
							<td nowrap style="max-width: 100px;">
							<small class="p-text-secondary" v-html="getFieldValue(historyHeader, right.item, field)"></small>
							</td>
						</tr>
					</template>
				</template>
			</Timeline>
		</Dialog>
		  <div class="flex flex-wrap justify-content-left gap-2 mb-2">
			  <Divider align="left" type="solid">
				<b>고객사</b>
			</Divider>
			<p>
				<AutoComplete v-model="company" optionLabel="companyName" dropdown :suggestions="filteredCompanys" @complete="companySearch" @change="setProjectList" style="width: 100%;"/>
			</p>

			<Divider align="left" type="solid">
				<b>프로젝트</b>
			</Divider>
			<p>
				<AutoComplete v-model="project" optionLabel="projectName" dropdown :suggestions="filteredProjects" @complete="projectSearch" @change="setProjectInfo"  style="width: 100%;"/>
			</p>

			<div v-if="partnerYn==='Y'">
				<Divider align="left" type="solid">
					<b>번들사</b>
				</Divider>
				<p>
					<input type="text" class="form-control" v-model="partnerName" disabled />
				</p>
			</div>

			<Divider align="left" type="solid">
				<b>영업대표</b>
			</Divider>
			<p>
				<input type="text" class="form-control" v-model="salesRepresentativeName" disabled />
			</p>


			<Divider align="left" type="solid">
				<b>발급제품</b>
			</Divider>
			<p v-if="isDesigner">
				<span class="p-tag p-tag-info" style="font-size: 1rem; padding: 4px 8px;">디자이너 6.0</span>
			</p>
			<p v-else-if="selectedLicenseTypeLocal === 'REPORT6'" style="display: flex; gap: 16px; align-items: center;">
				<span style="font-weight: bold; margin-right: 4px;">제품</span>
				<span>
					<input type="radio" v-model="report6ProdType" value="REPORT_ONLY" id="prodReportOnly" @change="syncReport6Prod" />
					<label for="prodReportOnly" style="margin-left: 4px;">리포트</label>
				</span>
				<span>
					<input type="radio" v-model="report6ProdType" value="EFORM_ONLY" id="prodEformOnly" @change="syncReport6Prod" />
					<label for="prodEformOnly" style="margin-left: 4px;">이폼</label>
				</span>
				<span>
					<input type="radio" v-model="report6ProdType" value="REPORT_EFORM" id="prodReportEform" @change="syncReport6Prod" />
					<label for="prodReportEform" style="margin-left: 4px;">리포트 + 이폼</label>
				</span>
			</p>
			<p v-else>
				<MultiSelect v-model="issuedProd" display="chip" :style="{ 'max-width': '100%'} " :options="issuedProds" optionLabel="label" placeholder="제품 선택" filter  :maxSelectedLabels="5" @change="issuedProdSearch" class="w-full md:w-20rem" />
			</p>
			<p v-if="selectedLicenseTypeLocal === 'REPORT6'" style="display: flex; gap: 16px; align-items: center;">
				<span style="font-weight: bold; margin-right: 4px;">상세 기능</span>
				<span>
					<input type="checkbox" v-model="report6Features" value="CLIP00015" id="featRepository" />
					<label for="featRepository" style="margin-left: 4px;">저장소</label>
				</span>
				<span>
					<input type="checkbox" v-model="report6Features" value="CLIP00016" id="featMirroring" />
					<label for="featMirroring" style="margin-left: 4px;">미러링</label>
				</span>
				<span>
					<input type="checkbox" v-model="report6Features" value="CLIP00017" id="featChat" />
					<label for="featChat" style="margin-left: 4px;">챗봇</label>
				</span>
			</p>

			<!-- DESIGNER6 전용 필드 -->
			<template v-if="isDesigner">
				<Divider align="left" type="solid">
					<b>Preset</b>
				</Divider>
				<p>
					<span style="margin-right: 16px;">
						<input type="radio" v-model="designerPreset" :value="1" id="preset1" />
						<label for="preset1" style="margin-left: 4px;">Standard (Report)</label>
					</span>
					<span>
						<input type="radio" v-model="designerPreset" :value="2" id="preset2" />
						<label for="preset2" style="margin-left: 4px;">Professional (Report+EForm)</label>
					</span>
				</p>

				<Divider align="left" type="solid">
					<b>고객사명 (customerId)</b>
				</Divider>
				<p>
					<InputText :value="company ? company.companyName : ''" disabled style="width: 100%;" />
				</p>

				<Divider align="left" type="solid">
					<b>기간</b>
				</Divider>
				<p>
					<span style="margin-right: 8px;">
						<input type="radio" v-model="designerPeriodType" value="TIME_LIMIT" id="d6PeriodTime" @change="designerPeriodTypeChange"/>
						<label for="d6PeriodTime">기간제</label>
					</span>
					<span>
						<input type="radio" v-model="designerPeriodType" value="INDEFINITELY" id="d6PeriodIndef" @change="designerPeriodTypeChange"/>
						<label for="d6PeriodIndef">무기한</label>
					</span>
				</p>
				<div v-if="designerPeriodType === 'TIME_LIMIT'">
					<p>
						<SelectButton v-model="designerPeriod369Val" :options="period369Arr" aria-labelledby="basic" @change="changeDesignerEndDate369"/>
					</p>
					<Divider align="left" type="solid">
						<b>만료일</b>
					</Divider>
					<p>
						<Calendar v-model="designerExpiryDate" dateFormat="yy/mm/dd" showIcon showButtonBar :showOnFocus="false" :minDate="new Date()" />
					</p>
				</div>
			</template>

			<!-- 기존 서버 관련 필드: DESIGNER6이 아니고 MirrorLink도 아닐 때 -->
			<div v-if="!isMirrorink && !isDesigner">
				<Divider align="left" type="solid">
					<b>HostName</b>
				</Divider>
				<p>
					<input v-model="hostName" class="form-control" @input="blockKorean" />
				</p>

				<Divider align="left" type="solid">
					<b>CPU</b>
				</Divider>
				<p>
					<InputNumber :min="0" v-model="cpuInfo" />
				</p>

				<Divider align="left" type="solid">
					<b>IP 타입</b>
				</Divider>
				<p>
					<span v-for="(ip) in ipTypes" :key="ip" style="margin-right: 8px;">
						<input type="radio" v-model="ipType" :value="ip.code" :id="ip.code" @change="unsetIpData"/>
						<label :for="ip.code">{{ip.label}}</label>
					</span>
				</p>

				<Divider align="left" type="solid" v-if="ipType !== 'ALL'">
					<b>IP</b>
				</Divider>
				<template v-if="ipType === 'MULTI'">
					<p v-for="row in ipRows" :key="row" style="display: flex; align-items: center; flex-wrap: nowrap;">
						<InputNumber v-model="row.ipAClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipBClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipCClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipDClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem; margin-right: 8px;"/>
						<Button label="삭제" icon="pi pi-minus" outlined @click="removeRow(row)" />
					</p>
					<p><Button label="IP추가" icon="pi pi-plus" severity="secondary" rounded @click="addRow(0)" />
					<Button label="IP복붙" icon="pi pi-copy" severity="info" rounded @click="copyAndPaste" v-tooltip.top="{
							value: '복사 예시) (+개행) \n\n192.168.0.100\n192.168.0.200\n192.168.0.300'
						}" style="margin-left:5px"/></p>
				</template>
				<template v-if="ipType === 'BANDWIDTH'">
					<p v-for="row in ipRows" :key="row">
						<InputNumber v-model="row.ipAClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputNumber v-model="row.ipBClass" :min="0" :max="255" @input="checkIP2($event.value)" inputStyle="width: 3.5rem" />.
						<InputText maxlength="3" v-model="row.ipCClass" style="width: 56px" @keyup="checkIP(row.ipCClass)"/>.
						<InputText type="text" v-model="row.ipDClass" value="*" disabled style="width: 56px; margin-right: 8px;"/>
						<Button label="삭제" icon="pi pi-minus" outlined @click="removeRow(row)" />
					</p>
					<p><Button label="IP추가" icon="pi pi-plus" severity="secondary" rounded @click="addRow('*')" /></p>

				</template>
			</div>
			<div v-if="this.isMirrorink">
				<Divider align="left" type="solid">
					<b>UUID</b>
				</Divider>
				<p>
					<input ref="uuidInput" v-model="uuid" class="form-control" disabled />
				</p>
			</div>
			<template v-if="!isDesigner">
				<Divider align="left" type="solid">
					<b>서버타입</b>
				</Divider>
				<p>
					<Dropdown v-model="serverType" editable :options="serverTypes" optionLabel="label" placeholder="서버타입을 선택해 주세요." class="w-full md:w-14rem" />
				</p>

				<Divider align="left" type="solid">
					<b>클라우드</b>
				</Divider>
				<p>
					<Checkbox v-model="cloudYn" value="Y"/>
				</p>

				<Divider align="left" type="solid">
					<b>기간</b>
				</Divider>
				<p>
					<span v-for="(period) in periodTypes" :key="period" style="margin-right: 8px;">
						<input type="radio" v-model="periodType" :value="period.code" :id="period.code"  @change="periodTypeCheck"/>
						<label :for="period.code">{{period.label}}</label>
					</span>
				</p>

				<div v-if="this.periodType === 'TIME_LIMIT'">
					<p>
						<SelectButton v-model="period369Val" :options="period369Arr" aria-labelledby="basic" @change="changeEndDate369"/>
					</p>
					<Divider align="left" type="solid">
						<b>효력일</b>
					</Divider>
					<p>
						<Calendar v-model="startDate" dateFormat="yy/mm/dd" showIcon showButtonBar :showOnFocus="false" />
					</p>

					<Divider align="left" type="solid">
						<b>만료일</b>
					</Divider>
					<p>
						<Calendar v-model="endDate" dateFormat="yy/mm/dd" showIcon showButtonBar :showOnFocus="false" />
					</p>
				</div>

				<div v-if="isDecode">
					<Divider align="left" type="solid">
						<b>효력일</b>
					</Divider>
					<p>
						<Calendar v-model="decodedLicense.sdate" showIcon showButtonBar disabled />
					</p>
				</div>
			</template>

			<Divider align="left" type="solid">
					<b v-if="this.isMirrorink">InitLicenseData.hcinsdata</b>
					<b v-else-if="isDesigner">시리얼 키</b>
					<b v-else-if="selectedLicenseTypeLocal === 'REPORT6'">JSON (복호화 시 전체 내용 사용)</b>
					<b v-else>key</b>
			</Divider>
			<p>
				<Textarea id = "keyTextArea" :value="selectedLicenseTypeLocal === 'REPORT6' ? displayIssuedLicense : issuedLicense" autoResize :rows="selectedLicenseTypeLocal === 'REPORT6' ? 10 : 4" disabled :style="{ 'font-family': 'Consolas,monaco,monospace', 'min-width': '100%', 'font-size': selectedLicenseTypeLocal === 'REPORT6' ? '11px' : 'inherit' }"/>
			</p>
			<p v-if="selectedLicenseTypeLocal === 'REPORT6'">
				<Button label="한줄로 전체 복사" icon="pi pi-copy" severity="secondary" size="small" @click="copyOneLiner" />
			</p>
			<div v-if="this.isMirrorink">
				<Divider align="left" type="solid">
						<b>License.hcinsKey</b>
				</Divider>
				<p>
					<Textarea id = "keyTextArea" v-model="issuedLicense2" autoResize rows="4" disabled :style="{ 'font-family': 'Consolas,monaco,monospace' ,'min-width': '100%'  }"/>
				</p>
			</div>
		  </div>
		  <template #footer>
			<Button label="닫기" id="licenseIssueCloseButton" icon="pi pi-times" @click="$emit('closesModal'); visible = false;" text />
			<Button label="발급" icon="pi pi-check" autofocus v-if="isIssuer == true" @click="handleIssueClick()" />
			<div class="flex align-items-center gap-2" style="margin: 15px 10px 0px 0px;">
				<span class="p-text-secondary"><b>{{ modifierName == "" ? registerName : modifierName }}</b></span><br>
				<span class="p-text-secondary"><div class="text-xs flex align-items-center text-700"><i class="pi pi-calendar mr-1 text-xs"></i> {{ modDate == null ? regDate : modDate }}</div></span>
			</div>
		</template>
		<div class="modal fade" id="updateConfirmMoral" tabindex="-1" aria-labelledby="updateConfirmMoralLabel" aria-hidden="true">
		  <div class="modal-dialog">
			<div class="modal-content">
			  <div class="modal-body">
				  <div class="mb-3">
					<label for="message-text" class="col-form-label">발급 내용</label>
					<textarea class="form-control" v-model="licenseComment" id="message-text" placeholder="라이선스 발급관련정보를 입력해 주세요." ></textarea>
				  </div>
			  </div>
			  <div class="modal-footer" v-if="processing == false">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="licenseIssuedCloseButton">닫기</button>
				<button type="button" class="btn btn-primary" @click="isDesigner ? updateDesigner() : update()" :data-bs-dismiss="modal">발급</button>
			  </div>
			  <div class="modal-footer" v-if="processing == true">
				<button class="btn btn-primary" type="button" disabled>
				  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
				  Please Wait...
				</button>
			  </div>
			</div>
		  </div>
		</div>

		<button id="openConfirmModalBtn" type="button" data-bs-toggle="modal" data-bs-target="#updateConfirmMoral" style="display:none;"></button>
	  </Dialog>
</template>

	<script>
	import _ from "lodash";
	export default {
	  name: 'LicenseInfoUpdateModal',
	  data(){
		return{
		  companys: [],
		  filteredCompanys: [],
		  filteredIssuedProds: [],
		  issuedProds: [],
		  projects: [],
		  filteredProjects: [],
		  filteredRequestDeptEmails: [],
		  ipTypes: [],
		  serverType: "",
		  serverTypes: {},
		  periodTypes: {},
		  licenseVersions: {},
		  company: "",
		  project: "",
		  projectSerialNo: "",
		  year: "",
		  issuedProd: "",
		  partnerName: "",
		  issueReqInfoYn: 'Y',
		  issueReqInfo: "",
		  cpuInfo: "",
		  ipType: "MULTI",
		  ipRows: [],
		  cloudYn: "",
		  startDate: "",
      	  endDate: "",
		  periodType: "TIME_LIMIT",
		  licenseVersion: "V3",
		  visible: true,
		  visible2: false,
		  modalWidth: this.$isMobile() ? '100vw' : '35vw',
		  innerModalvisible: false,
		  licenseComment: "",
		  issuedLicense: "",
		  issuedLicense2: "",
		  etc: "",
		  issueStatusType: "",
		  partnerYn: "",
		  licenseSerialNo: "",
		  processing: false,
		  requestInfo : "",
		  modifierName: "",
		  modDate: "",
		  registerName: "",
		  regDate: "",
		  licenseHistoryList: [],
		  historyHeader: ["수정일","수정자","수정내용", "발급상태", "고객사", "프로젝트","제품", "CPU", "IP", "서버타입", "클라우드", "시작일", "종료일", "Key", "호스트명"],
		  details: {},
		  period369Arr:['3개월','6개월','12개월'],
		  period369Val:'',
		  decodedLicense: {},
		  isDecode: false,
		  hostName: "",
		  isMirrorink: false,
		  uuid: "",
		  selectedLicenseTypeLocal: 'LEGACY',
		  isDesigner: false,
		  report6ProdType: 'REPORT_ONLY',
		  // [상세기능] 저장소/미러링/챗봇. 제품과 독립적으로 복수 선택 가능
		  report6Features: [],
		  designerLicenseComment: '',
		  designerPreset: 2,
		  designerExpiryYmdStr: '',
		  designerExpiryDate: null,
		  designerPeriodType: 'TIME_LIMIT',
		  designerPeriod369Val: '',
		  designerCustomerId: 1,
		  designerProduct: 1,
		  designerNonce: 0,
		  wasIssued: false,
		  designerSerialKey: '',
		}
	  },
	  props: {
		  detailsCompanySeq: Number,
		  detailsProjectUid: String,
		  detailsLicenseSeq: Number,
		  isIssuer: Boolean,
	  },
	  components: {
	  },
	  created(){
		var param = {
		};
		this.$code(["PROD_CODE"], false,
			function(result, i){
				i.issuedProds = result.prodCode;
			},
			function(e, i){
				console.log(e);
			}
		);
	  }, watch: {
		isMirrorink(){},
		selectedLicenseTypeLocal: function(val) {
			if (val === 'DESIGNER6') {
				this.isDesigner = true;
				this.licenseVersion = 'DESIGNER6';
				var self = this;
				var designer = this.issuedProds.find(function(p) { return p.value === 'CLIP00009'; });
				if (designer) { self.issuedProd = [designer]; }
				var local = this.serverTypes.find ? this.serverTypes.find(function(s) { return s.value === 'LOCAL'; }) : null;
				if (local) { self.serverType = local; }
			} else {
				this.isDesigner = false;
				this.licenseVersion = 'V3';
			}
		}
	  },
	  mounted(){
			  this.$nextTick(function() {
				  this.setLicenseInfo();
			});
			//달력(속성 변경)
			this.$calendar();
	  },
	  computed: {
		displayIssuedLicense() {
			if (this.selectedLicenseTypeLocal === 'REPORT6' && this.issuedLicense) {
				try {
					var parsed = JSON.parse(this.issuedLicense);
					return JSON.stringify(parsed, null, 2);
				} catch(e) {
					return this.issuedLicense;
				}
			}
			return this.issuedLicense;
		}
	  },
	  methods: {
		setLicenseInfo(){
			this.$get(`/biz/license/get`, {
							params: {
									companySeq : this.detailsCompanySeq,
									projectUid : this.detailsProjectUid,
									licenseSeq : this.detailsLicenseSeq,
								}
							},
						function(response, i){
							var detail = response.data.detail;
							i.details = detail;
							i.modifierName = detail.modifierName;
							i.modDate = detail.modDate;
							i.registerName = detail.registerName;
							i.regDate = detail.regDate;

							i.$get('/biz/company/list',  {
											params: {}
											},
										function(response, i){

											   i.companys = response.data.result;   //기존데이터에 추가
											   i.companys.forEach(function(company, index) {
												if(detail.companySeq === company.companySeq){
													i.company = company;
												}
											});
										},
										function(e, i){
											console.log(e);
										}
							 );


							i.$code(["IP_TYPE", "SERVER_TYPE", "PERIOD_TYPE", "LICENSE_VERSION", "PROD_CODE"], false,
								function(result, i){

								   i.ipTypes = result.ipType;
								   i.serverTypes = result.serverType;
								   i.periodTypes = result.periodType;
								   i.licenseVersions = result.licenseVersion;
								   i.issuedProds = result.prodCode.filter(item => (item.codeSort < 10 && item.codeSort >= 1) || item.codeSort >= 1000);

								   i.serverTypes.forEach(function(serverType, index) {
										if(detail.serverType === serverType.value){
									   i.serverType = serverType;
										 }
									});

									if(detail.issueStatusType != "ISSUED"){
										i.licenseComment =  "최초 발급";

										var deliveryProds = [];

									   result.prodCode.forEach(function(deliveryProd, index) {
											detail.deliveryProdCode.split(",").forEach(function(prodCode, index) {
												if(prodCode === deliveryProd.value){
													deliveryProds.push(deliveryProd);
												}
											});

										});

										i.issuedProd = deliveryProds;


									}else{
										 if(detail.issuedProdCode != null && detail.issuedProdCode.length > 0){
											var issuedProds = [];

											i.issuedProds.forEach(function(issuedProd, index) {
												detail.issuedProdCode.split(",").forEach(function(prodCode, index) {
													if(prodCode === issuedProd.value){
														issuedProds.push(issuedProd);
													}
												});

											});

											i.issuedProd = issuedProds;

										}
									}

								   i.isMirrorink = detail.deliveryProdCode == "CLIP03001" ? true : false;

								   // licenseVersion에 따라 selectedLicenseTypeLocal / isDesigner 설정
								   if (detail.licenseVersion === 'DESIGNER6') {
									   i.isDesigner = true;
									   i.selectedLicenseTypeLocal = 'DESIGNER6';
									   i.designerPreset = detail.designerPreset != null ? detail.designerPreset : 2;
									   i.designerCustomerId = detail.designerCustomerId != null ? detail.designerCustomerId : 1;
									   // endDate (예: "2099/12/31") -> designerExpiryYmdStr ("20991231")
									   if (detail.endDate) {
										   i.designerExpiryYmdStr = detail.endDate.replace(/\//g, '').replace(/-/g, '');
										   var dateParts = detail.endDate.split('/');
										   if (dateParts.length === 3) {
										      i.designerExpiryDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
										      i.designerPeriodType = (parseInt(dateParts[0]) >= 9999) ? 'INDEFINITELY' : 'TIME_LIMIT';
										   }
									   } else {
										   i.designerPeriodType = 'INDEFINITELY';
									   }
								   } else if (detail.licenseVersion === 'REPORT6') {
									   i.selectedLicenseTypeLocal = 'REPORT6';
								   } else {
									   i.selectedLicenseTypeLocal = 'LEGACY';
								   }
								   // 제품 목록 필터링
								   var newCodes = ['CLIP00007', 'CLIP00008', 'CLIP00009', 'CLIP00010', 'CLIP00015', 'CLIP00016', 'CLIP00017'];
								   if (detail.licenseVersion === 'DESIGNER6') {
									   var d6Codes = ['CLIP00009', 'CLIP00010'];
									   i.issuedProds = i.issuedProds.filter(function(p) { return d6Codes.indexOf(p.value) !== -1; });
									   var isStandard = detail.issuedProdCode && detail.issuedProdCode.indexOf('CLIP00010') !== -1;
									   i.issuedProd = i.issuedProds.filter(function(p) { return isStandard ? p.value === 'CLIP00010' : p.value === 'CLIP00009'; });
								   } else if (detail.licenseVersion === 'REPORT6') {
									   var r6Codes = ['CLIP00007', 'CLIP00008'];
									   i.issuedProds = i.issuedProds.filter(function(p) { return r6Codes.indexOf(p.value) !== -1; });
									   // [REQ] 기존 제품코드 -> 선택 복원
									   //   제품(택1)  CLIP00007 + CLIP00008 -> REPORT_EFORM (리포트+이폼)
									   //              CLIP00008 만          -> EFORM_ONLY   (이폼)
									   //              그 외 / 없음          -> REPORT_ONLY  (기본값)
									   //   상세기능   CLIP00015/16/17 포함 여부로 체크박스 복원 (복수)
									   var r6Pc  = detail.issuedProdCode || '';
									   var r6Has = r6Pc.indexOf('CLIP00007') !== -1;
									   var e6Has = r6Pc.indexOf('CLIP00008') !== -1;
									   i.report6ProdType = (r6Has && e6Has) ? 'REPORT_EFORM' : (e6Has ? 'EFORM_ONLY' : 'REPORT_ONLY');
									   i.report6Features = ['CLIP00015', 'CLIP00016', 'CLIP00017'].filter(function(c) {
									   	return r6Pc.indexOf(c) !== -1;
									   });
									   i.syncReport6Prod();
								   } else {
									   i.issuedProds = i.issuedProds.filter(function(p) { return newCodes.indexOf(p.value) === -1; });
									   if (Array.isArray(i.issuedProd)) {
										   i.issuedProd = i.issuedProd.filter(function(p) { return newCodes.indexOf(p.value) === -1; });
									   }
								   }

								},
								function(e, i){
									console.log(e);
								}
							);

							i.$get('/biz/project/list',  {
											params: {
													companySeq : detail.companySeq,
												}
								 },
									function(response, i){

										const current = new Date();
										i.projects = response.data.result;   //기존데이터에 추가
										i.projects.forEach(function(project, index) {
											if(detail.companySeq === project.companySeq && detail.projectUid === project.projectUid){
												i.project = project;
												i.partnerName = project.partnerName;
												i.salesRepresentativeName = project.salesRepresentativeName;
												i.year = project.year !== "" ? project.year : current.getFullYear();
												i.licenseSerialNo = project.projectSerialNo;

											}
										});
									},
									function(e, i){
										console.log(e);
									}
							);

							i.issueReqInfoYn = detail.issueReqInfoYn;
							i.issueReqInfo = detail.issueReqInfo;
							i.cpuInfo = detail.cpuInfo;
							i.hostName = detail.hostName;
							i.ipType = detail.ipType;
							i.requestInfo = detail.requestInfo;


							if(detail.ipType != 'ALL'){
								var ips = detail.ipAddress.split(',');

								ips.forEach(function(ip, index) {
									var tempIp = ip.split('.');
									i.ipRows.push({ipAClass: tempIp[0], ipBClass: tempIp[1], ipCClass: tempIp[2], ipDClass: tempIp[3]});

								});
							}

							if(detail.cloudYn != null && detail.cloudYn != ""){
								i.cloudYn = [detail.cloudYn];
							} else {
								i.cloudYn = null;
							}

							i.periodType = detail.periodType;

							if(detail.licenseVersion != null){
								i.licenseVersion = detail.licenseVersion;
							}

							i.issuedLicense = detail.issuedLicense;
							i.issuedLicense2 = detail.issuedLicense2;
							i.uuid = detail.uuid;

							i.etc = detail.etc;

							i.issueStatusType = detail.issueStatusType;

							if(detail.periodType != "TIME_LIMIT"){
								i.startDate = "";
								i.endDate = "";

								var param = {
									encodedLicenseKey : i.issuedLicense,
									licenseVersion : i.licenseVersion,
								};
								i.$get('/biz/license/decode',  {
											params: param
									},
									function(response, i){
										i.decodedLicense = response.data.decodeResult;   //기존데이터에 추가
										i.isDecode = true;
									},
									function(e, i){
										console.log(e);
									}
								);
							}else{
								i.startDate = new Date(detail.startDate);
								i.endDate = new Date(detail.endDate);
							}
						},
						function(e, i){
							console.log(e);
						}
		  );

		},
		  periodTypeCheck(){
			  if(this.periodType != "TIME_LIMIT"){
				  this.startDate = "";
				  this.endDate = "";
			  }else{
				  this.startDate = new Date();
			  }
		},
		changeEndDate369(){
			if(this.period369Val != null) {
				var N_MonthsLater = new Date(this.startDate);
				N_MonthsLater.setMonth(N_MonthsLater.getMonth() + Number(this.period369Val.split('개월')[0]));
				this.endDate = new Date(N_MonthsLater);
			}
		},
		  update() {
			var checked = false;
			var ipAddresses = [];
			var issuedProdCodes = [];

			// [REQ] REPORT6 는 라디오+체크박스 선택값으로 제품코드를 확정한다.
			// 상세기능 코드(CLIP00015~17)는 codeSort 필터 때문에 issuedProds 에 없으므로
			// issuedProd 를 거치지 않고 report6ProdCodes() 로 직접 구성해야 한다.

			if (this.selectedLicenseTypeLocal === 'REPORT6') {
				issuedProdCodes = this.report6ProdCodes();
			} else if(this.issuedProd != null && this.issuedProd != 'undefined' && this.issuedProd != ''){

					  this.issuedProd = _.uniqBy(this.issuedProd, 'value');

					this.issuedProd.forEach(function(prod, index) {
					  issuedProdCodes.push(prod.value);
					});

					if(issuedProdCodes.length < 1){
						  this.$messageShow('도입제품은 한개이상 필수선택항목입니다.', 'warn');
						  return checked;
					  }

				  }else{
					  this.$messageShow('도입제품은 한개이상 필수선택항목입니다.', 'warn');
					  return checked;
				  }

			if((this.cpuInfo == null || this.cpuInfo == "" || this.cpuInfo == 0) && this.isMirrorink == false && this.selectedLicenseTypeLocal !== 'REPORT6') {
			  this.$messageShow('CPU 정보는 필수입력항목입니다.', 'warn');
			  return checked;
			}

			if(this.ipType != 'ALL'){

				if(this.ipRows.length < 1){
					if(this.selectedLicenseTypeLocal !== 'REPORT6') {
					  this.$messageShow('IP 정보는 한개 이상 입력이 필요합니다.', 'warn');
					  return checked;
					}
				}else{
					this.ipRows.forEach(function(ip, index) {

					  if(ip.ipAClass == null || ip.ipAClass == ""){
						  ip.ipAClass = 0;
					  }
					  if(ip.ipBClass == null || ip.ipBClass == ""){
						  ip.ipBClass = 0;
					  }
					  if(ip.ipCClass == null || ip.ipCClass == ""){
						  ip.ipCClass = 0;
					  }
					  if(ip.ipDClass == null || ip.ipDClass == ""){
						  ip.ipDClass = 0;
					  }
					  ipAddresses.push(ip.ipAClass + '.' + ip.ipBClass + '.' + ip.ipCClass + '.' + ip.ipDClass);
					});
				}

			}

			if(this.serverType == "" && this.selectedLicenseTypeLocal !== 'REPORT6') {
			  this.$messageShow('서버타입은 필수입력항목입니다.', 'warn');
			  return checked;
			}

			if(this.periodType == "TIME_LIMIT"){
				if(this.startDate == "" || this.endDate == "" || this.startDate == null || this.endDate == null){
					  this.$messageShow('효력일, 만료일 입력이 필요합니다.', 'warn');
					return checked;
				}else{
						if(this.startDate > this.endDate){
							this.$messageShow('만료일이 효력일보다 빠른날짜 입니다. 기간 확인이 필요합니다.', 'warn');
							return checked;
						}
				}
			}

			if(this.licenseComment == ""){
				this.$messageShow('발급 내용 입력이 필요합니다.', 'warn');
				return checked;
			}else{
				checked = true;
			}

			const dissuedProdCode_s = this.details.issuedProdCode != null ? this.details.issuedProdCode.split(',').sort() : "";
			const issuedProdCodes_s = issuedProdCodes.sort();
			const dipAddress_s = this.details.ipAddress != null ? this.details.ipAddress.split(',').sort() : "";
			const ipAddresses_s = ipAddresses != null && ipAddresses.length != 0 ? ipAddresses.sort() : "";

			if (this.details.companyName == this.company.companyName
			&& this.details.projectName == this.project.projectName
			&& JSON.stringify(dissuedProdCode_s) == JSON.stringify(issuedProdCodes_s)
			&& this.details.cpuInfo == this.cpuInfo
			&& this.details.hostName == this.hostName
			&& this.details.ipType == this.ipType
			&& JSON.stringify(dipAddress_s) == JSON.stringify(ipAddresses_s)
			&& this.details.serverType == (this.serverType && this.serverType.value ? this.serverType.value : this.serverType)
			&& (this.details.cloudYn == "" ||this.details.cloudYn == null || this.details.cloudYn ? '' : this.details.cloudYn)  == (this.cloudYn == "" ||this.cloudYn == null || this.cloudYn === undefined ? '' : this.cloudYn[0])
			&& this.details.startDate == (this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.startDate, "yyyy/MM/dd") : "")
			&& this.details.endDate == (this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.endDate, "yyyy/MM/dd") : "")) {
						checked = false;
						this.$messageShow('기존 정보와 같습니다.', 'warn');
						return checked;
			}

			if(checked){
				if(confirm("라이선스 발급을 진행하시겠습니까?")){
					this.processing = true;
					var param = {
					  "licenseSeq" : this.detailsLicenseSeq,
					  "companySeq": this.company.companySeq ,
					  "companyName": this.company.companyName ,
					  "projectUid": this.project.projectUid ,
					  "projectName": this.project.projectName ,
					  "issueReqInfoYn" : 'Y',
					  "cpuInfo": this.cpuInfo,
					  "ipType": this.ipType,
					  "ipFrom" : ipAddresses,
					  "serverType": this.serverType && this.serverType.value ? this.serverType.value : (this.serverType || ""),
					  "cloudYn": this.cloudYn != null ? this.cloudYn[0] : "",
					  "periodType": this.periodType,
					  "startDate" : this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.startDate, "yyyy/MM/dd") : "",
					  "endDate" : this.periodType == "TIME_LIMIT" ? this.$simpleDateTimeFormat(this.endDate, "yyyy/MM/dd") : "",
					  "issueReqInfo" : this.issueReqInfo,
					  "registerEmail" : this.$store.getters.getUserEmail,
					  "modifierEmail" : this.$store.getters.getUserEmail,
					  "issueStatusType" : "ISSUED",
					  "etc" : this.etc,
					  "licenseComment" : this.licenseComment,
					  "licenseVersion" : this.licenseVersion,
					  "issuedProdCodes" : issuedProdCodes,
					  "licenseSerialNo" : this.licenseSerialNo,
					  "requestInfo" : this.requestInfo,
					  "hostName" : this.hostName,
					  "uuid" : this.uuid,
					};

					this.$post('/biz/license/issue', param,
								function(response, i){
									i.processing = false;
									 var detail = response.data.detail;
									i.issuedLicense = detail.issuedLicense;

									if(i.isMirrorink) {
										i.issuedLicense2 = detail.issuedLicense2;
										i.uuid = detail.uuid;
									}

									i.$messageShow('라이선스 발급이 완료되었습니다.', 'success');
									i.wasIssued = true;

									setTimeout(() => {
										document.getElementById("licenseIssuedCloseButton").click();
										document.getElementById("keyTextArea").scrollIntoView({ behavior: "smooth" });
									}, 100);
								},
								function(e, i){
									i.processing = false;
									i.errorMessage = e;
								}
					 );
				}

			}

		},
		setProjectList() {
			this.partnerName = "";
			this.salesRepresentativeName = "";
			this.project = "";

			var param = {
				companySeq : this.company.companySeq,
			};

			this.$get('/biz/project/list',  {
							params: param
				 },
					function(response, i){
						i.projects = response.data.result;   //기존데이터에 추가
					},
					function(e, i){
						console.log(e);
					}
			);

		},
		companySearch(event) {
				 setTimeout(() => {
					if (!event.query.trim().length) {
						this.filteredCompanys = this.companys.filter((company) => company.useYn === 'Y');
					} else {
						this.filteredCompanys = this.companys.filter((company) => {
							return company.useYn === 'Y' && company.companyName.toLowerCase().includes(event.query.toLowerCase());
						});
					}
				}, 250);


		},
		projectSearch(event) {
				 setTimeout(() => {
					if (!event.query.trim().length) {
						this.filteredProjects = this.projects.filter((project) => project.useYn === 'Y');
					} else {
						this.filteredProjects = this.projects.filter((project) => {
							return project.useYn === 'Y' &&  project.projectName.toLowerCase().includes(event.query.toLowerCase());
						});
					}
				}, 250);

		},
		setProjectInfo(){
			var param = {
				companySeq : this.project.companySeq,
				projectUid : this.project.projectUid
			};

			  this.$get(`/biz/project/get`, {
							params: param
							},
							function(response, i){
								i.issuedProd = null;
								i.partnerName = response.data.detail.partnerName;
								i.salesRepresentativeName = response.data.detail.salesRepresentativeName;
								i.partnerYn = response.data.detail.partnerYn;

							},
							function(e, i){
								console.log(e);
							}
			 );

		},
		addRow: function(ipDClass){
		  this.ipRows.push({ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: ipDClass});
		},
		removeRow: function(row){
		  this.ipRows.splice(this.ipRows.indexOf(row), 1);
		},
		checkIP: function(ipCClass){
			var regExp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|\*)$/i;
			if(!regExp.test(ipCClass)){
				this.$messageShow("IP 주소는 클래스별 0부터 255사이의 숫자 또는 '*'문자를 이용하여 입력을 해야 합니다.", 'warn');
				return false;
			}
		},
		checkIP2: function(ipCClass){
			var regExp = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;
			if(!regExp.test(ipCClass)){
				this.$messageShow("IP 주소는 클래스별 0부터 255사이의 숫자를 이용하여 입력을 해야 합니다.", 'warn');
				return false;
			}
		},
		unsetIpData: function(){
			if(this.ipType == 'ALL'){
				this.ipRows = [];
			}else{
				if(this.ipType == 'MULTI'){
					this.ipRows = [{ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: 0}];
				}else{
					this.ipRows = [{ipAClass: 0, ipBClass: 0, ipCClass: 0, ipDClass: '*'}];
				}
			}
		},
		// [REQ-F-001] REPORT6 도입제품 3분기 -> 제품코드 매핑 (단일 진실 공급원)
		//   REPORT_ONLY  (R6)  : CLIP00007
		//   EFORM_ONLY   (E6)  : CLIP00008
		//   REPORT_EFORM (RE6) : CLIP00007 + CLIP00008
		// [REQ] 제품은 택1 필수, 상세기능은 그 위에 복수 선택 가능.
		//   제품     REPORT_ONLY  (R6)  : CLIP00007
		//            EFORM_ONLY   (E6)  : CLIP00008
		//            REPORT_EFORM (RE6) : CLIP00007 + CLIP00008
		//   상세기능 CLIP00015(저장소) / CLIP00016(미러링) / CLIP00017(챗봇)
		// 제품 라디오는 기본값이 있어 항상 하나가 선택된 상태이므로 필수 조건이 자동 충족된다.
		report6ProdCodes() {
			var codes;
			switch (this.report6ProdType) {
				case 'EFORM_ONLY':   codes = ['CLIP00008']; break;
				case 'REPORT_EFORM': codes = ['CLIP00007', 'CLIP00008']; break;
				default:             codes = ['CLIP00007']; break;
			}
			return codes.concat(this.report6Features || []);
		},
		syncReport6Prod() {
			var codes = this.report6ProdCodes();
			this.issuedProd = this.issuedProds.filter(function(p) { return codes.indexOf(p.value) !== -1; });
		},
		copyOneLiner() {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(this.issuedLicense).then(() => {
					this.$messageShow('한 줄 JSON이 클립보드에 복사되었습니다.', 'success');
				}).catch(() => {
					this.$messageShow('복사에 실패했습니다. https 환경인지 확인해주세요.', 'warn');
				});
			} else {
				this.$messageShow('https 에서만 지원합니다.', 'warn');
			}
		},
		issuedProdSearch(event) {
			if(event.value.some(item => item.code.includes("CLIP03001"))) {
				if(event.value.length > 1) {
					this.$messageShow("MirrorLink는 단독으로만 사용 가능합니다.", 'warn');
					this.issuedProd = event.value.filter(item => item.code !== "CLIP03001");
					this.isMirrorink = false;
				} else {
					this.isMirrorink = true;
				}
			} else {
				this.isMirrorink = false;
			}
		},
		getLicenseHistory() {
			var param = {
				licenseSeq : this.detailsLicenseSeq,
			};
			this.$get('/biz/license/getH',  {
							params: param
					},
					function(response, i){
						i.historyHeader = i.isMirrorink ? ["수정일","수정자","수정내용", "발급상태", "고객사", "프로젝트","제품", "CPU", "IP", "서버타입", "클라우드", "시작일", "종료일", "InitLicenseData.hcinsdata", "License.hcinsKey", "hostname", "uuid"] : ["수정일","수정자","수정내용", "발급상태", "고객사", "프로젝트","제품", "CPU", "IP", "서버타입", "클라우드", "시작일", "종료일", "Key", "호스트명"];
						i.licenseHistoryList = response.data.detailHistory;
					},
					function(e, i){
						console.log(e);
					}
			);

		},
		getNextLicenseName(header, item) {
			const currentIndex = this.licenseHistoryList.indexOf(item);

			var properties = Object.keys(item).map((key) => key);
			var rtValue = {};

			if (currentIndex < this.licenseHistoryList.length - 1) {
				for (let i = 0; i < header.length; i++) {
					let property = properties[i];
					rtValue[property] = (this.licenseHistoryList[currentIndex][property] == this.licenseHistoryList[currentIndex + 1][property] ? "" : header[i] + '|*|' + (this.licenseHistoryList[currentIndex][property] != null ? this.licenseHistoryList[currentIndex][property] : ""));
				}
			} else {
				for (let i = 0; i < header.length; i++) {
				let property = properties[i];
				rtValue[property] = header[i] + '|*|' + (this.licenseHistoryList[currentIndex][property] != null ? this.licenseHistoryList[currentIndex][property] : "");
				}
			}
			return rtValue;
		},
		addNewLine(value) {
			if(value != undefined && value != null) {
				if(value.indexOf('.') == -1 && value.indexOf('allip') == -1)
					return value;
				else
					return value.replace(/,/g, '<br>');

			}
		},
		copyAndPaste(){
			if(navigator.clipboard == null){
				this.$messageShow("https 에서만 지원 합니다.", 'warn');
			} else {
				var ipRows_prev = this.ipRows;
				this.ipRows = [];

				setTimeout(() => {
						navigator.clipboard.readText().then(text => {
						const lines = text.split('\r\n');
						for (let i = 0; i < lines.length; i++) {
							const ipAddressParts = lines[i].split('.');

							var regExp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;
							if(!regExp.test(lines[i])) {
								this.$messageShow(i+1+ "번째 IP 주소가 잘 못 되었습니다.", 'warn');
								this.ipRows = ipRows_prev;
								break;
							} else {
								if (ipAddressParts.length === 4 && (this.checkIP2(ipAddressParts[0]) != false && this.checkIP2(ipAddressParts[1])) != false && this.checkIP2(ipAddressParts[2]) != false && this.checkIP2(ipAddressParts[3]) != false) {
								this.addRow(i);
								const newRow = this.ipRows[i];
								newRow.ipAClass = parseInt(ipAddressParts[0]);
								newRow.ipBClass = parseInt(ipAddressParts[1]);
								newRow.ipCClass = parseInt(ipAddressParts[2]);
								newRow.ipDClass = parseInt(ipAddressParts[3]);
								} else {
									this.ipRows = ipRows_prev;
								}
							}
						}
					}).catch(err => {
						console.error('Failed to read clipboard contents: ', err);
					});
				}, 300);
			}
		},
		blockKorean(event) {
			const original = event.target.value
			const filtered = original
				.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '') // 한글 제거
				.replace(/\s/g, '')               // 모든 공백(띄어쓰기 포함) 제거
				.trim()                           // 앞뒤 공백 제거 (보통 \s 제거로 충분하지만 안정성 ↑)
			event.target.value = filtered
		},
		shouldRenderField(historyHeader, item, field, index) {
			if (index < 2) return false;

			const fieldValue = this.getNextLicenseName(historyHeader, item)[field];
			if (!fieldValue) return false;

			const splitValue = fieldValue.split('|*|');
			return splitValue[1] && splitValue[1].trim() !== '';
		},
		getFieldTitle(historyHeader, item, field) {
			const fieldValue = this.getNextLicenseName(historyHeader, item)[field];
			return fieldValue ? fieldValue.split('|*|')[0] : '';
		},
		getFieldValue(historyHeader, item, field) {
			const fieldValue = this.getNextLicenseName(historyHeader, item)[field];
			const value = fieldValue ? fieldValue.split('|*|')[1] : '';
			return this.addNewLine(value);
		},
		handleDialogClose() {
			if (this.wasIssued) {
				this.$emit('update');
			}
			this.$emit('closesModal');
			this.visible = false;
		},
		handleIssueClick() {
			if (this.isDesigner) {
				if (this.designerPeriodType === 'TIME_LIMIT') {
					if (!this.designerExpiryDate) {
						this.$messageShow('만료일을 선택해주세요.', 'warn');
						return;
					}
					var today = new Date(); today.setHours(0,0,0,0);
					if (this.designerExpiryDate < today) {
						this.$messageShow('만료일은 오늘 이후 날짜를 선택해주세요.', 'warn');
						return;
					}
				}
				this.$nextTick(function() {
					document.getElementById('openConfirmModalBtn').click();
				});
			} else {
				if (this.selectedLicenseTypeLocal === 'REPORT6') {
					this.licenseVersion = 'REPORT6';
					// report6ProdType(REPORT_ONLY/EFORM_ONLY/REPORT_EFORM) 선택값을 반영하여 발급 제품 결정
					// REPORT_ONLY  -> CLIP00007(리포트)만
					// EFORM_ONLY   -> CLIP00008(이폼)만
					// REPORT_EFORM -> CLIP00007(리포트) + CLIP00008(이폼)
					this.syncReport6Prod();
				}
				this.$nextTick(function() {
					document.getElementById('openConfirmModalBtn').click();
				});
			}
		},
		designerPeriodTypeChange() {
			this.designerExpiryDate = null;
			this.designerPeriod369Val = '';
		},
		changeDesignerEndDate369() {
			if (this.designerPeriod369Val) {
				var months = parseInt(this.designerPeriod369Val.split('개월')[0]);
				var d = new Date();
				d.setMonth(d.getMonth() + months);
				this.designerExpiryDate = d;
			}
		},
		updateDesigner() {
			if (!this.licenseComment || this.licenseComment.trim() === '') {
				this.$messageShow('발급 내용 입력이 필요합니다.', 'warn');
				return;
			}
			this.processing = true;
			var expiryYmd;
			if (this.designerPeriodType === 'INDEFINITELY') {
				expiryYmd = 99991231;
			} else {
				var d = this.designerExpiryDate;
				expiryYmd = d ? d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate() : 0;
			}
			var param = {
				"licenseSeq": this.detailsLicenseSeq,
				"companySeq": this.company.companySeq,
				"companyName": this.company.companyName,
				"projectUid": this.project.projectUid,
				"projectName": this.project.projectName,
				"issueReqInfoYn": 'Y',
				"registerEmail": this.$store.getters.getUserEmail,
				"modifierEmail": this.$store.getters.getUserEmail,
				"issueStatusType": "ISSUED",
				"useYn": "Y",
				"licenseComment": this.licenseComment,
				"licenseVersion": "DESIGNER6",
				"issuedProdCodes": this.designerPreset === 2 ? ["CLIP00009"] : ["CLIP00010"],
				"preset": this.designerPreset,
				"aiFlags": 0,
				"designerCustomerId": this.company ? this.company.companySeq : 0,
				"designerExpiryYmd": expiryYmd,
				"designerProduct": this.designerProduct,
				"designerNonce": this.designerNonce,
				"serverType": "LOCAL",
				"ipType": "ALL",
				"ipFrom": [],
				"cpuInfo": "0",
				"cloudYn": "N",
				"periodType": "TIME_LIMIT",
				"hostName": "",
			};
			this.$post('/biz/license/issue', param,
				function(response, i) {
					i.processing = false;
					var detail = response.data.detail;
					i.designerSerialKey = detail ? (detail.issuedLicense || '') : '';
					i.issuedLicense = i.designerSerialKey;
					i.wasIssued = true;
					i.$messageShow('디자이너 라이선스 발급이 완료되었습니다.', 'success');
					setTimeout(function() {
						document.getElementById("licenseIssuedCloseButton").click();
						document.getElementById("keyTextArea").scrollIntoView({ behavior: "smooth" });
					}, 100);
				},
				function(e, i) {
					i.processing = false;
					i.$messageShow('라이선스 발급에 실패했습니다. 라이선스 서버 상태를 확인하세요.', 'error');
				}
			);
		}
	  }
	}
	</script>

	<style scoped>
	.black-bg {
	  width: 100%;
	  height: 100%;
	  background: rgba(0,0,0,0.5);
	  position: fixed;
	  padding: 20px;
	}
	.white-bg {
	  width: 400px;
	  background: white;
	  border-radius: 8px;
	  padding: 20px;
	  margin: 0 auto;
	  transform: translate(-50%, 5%);
	}
	h4 {
	  padding-bottom: 10px;
	  margin-bottom: 20px;
	  border-bottom: 1px solid rgb(169, 168, 168);
	}
	.check {
	  margin-left: 40px;
	}
	</style>

